export const redirectAfterFailedSessionRecovery = async (sessionRecoveryFailed, userStore, router) => {
  if (!sessionRecoveryFailed) return false

  userStore.cleanToken()
  await router.replace({ name: 'login' })
  return true
}
